module.exports = __webpack_public_path__ + "img/05.a34d00a8.jpg";